import { mode } from '@chakra-ui/theme-tools';

const disable = {
  _disabled: {
    opacity: '1 !important',
    bg: '#0F1426 !important',
    color: '#4C505C !important',
    _hover: {
      bg: '#0F1426 !important',
    },
    _active: {
      bg: '#0F1426 !important',
    },
    'svg > path': {
      color: '#4C505C !important', 
    }
  },
};

const baseStyle = {
  fontSize: '16px !important',
  w: '100% !important',
  color: 'white !important',
  borderRadius: '16px !important',
  fontWeight: '600',
  lineHeight: '21px',
  letterSpacing: '-0.4px',
  ...disable
};

const buttonStyle = {
  ...baseStyle,
  bg: '#ea9e29 !important',
  _hover: {
    bg: '#ea9e29 !important',
  },
  _active: {
    bg: '#ea9e29 !important',
  },
  _focus: {
    outline: 'unset',
    boxShadow: 'unset'
  }
};

const secondaryStyle = {
  ...baseStyle,
  bg: '#0E1633 !important',
  _hover: {
    bg: '#0D234D !important',
  },
  _active: {
    bg: '#0E1633 !important',
  },
  _focus: {
    outline: 'unset',
    boxShadow: 'unset'
  }
};

const solidStyle = {
  ...baseStyle,
  border: '1px solid #eca515',
  backdropFilter: 'unset !important',
  _hover: {
    bg: 'rgb(255, 187, 24) !important',
  },
  _active: {
    bg: 'transparent !important',
  },
  _focus: {
    outline: 'unset',
    boxShadow: 'unset'
  }
};

const ghostStyle = {
  ...baseStyle,
  border: 'unset !important',
  backdropFilter: 'unset !important',
  bg: 'transparent !important',
  _hover: {
    bg: 'transparent !important',
  },
  _active: {
    bg: 'transparent !important',
  },
  _focus: {
    outline: 'unset',
    boxShadow: 'unset'
  }
};

const stylesLg = {
  h: '56px !important',
  p: '5px 10px !important',
};

const stylesMd = {
  h: '44px !important',
  p: '5px 10px !important',
};

const stylesSm = {
  h: '36px !important',
  p: '8px !important',
};

const shadowStyle = {
  boxShadow: '0px 1px 22.4px 0px rgba(9, 155, 255, 0.60)'
};

export const buttonStyles = {
  components: {
    Button: {
      variants: {
        'button-lg': {...buttonStyle, ...stylesLg},
        'button-md': {...buttonStyle, ...stylesMd},
        'button-sm': {...buttonStyle, ...stylesSm},
        'button-lg-g': {...buttonStyle, ...stylesLg, ...shadowStyle},
        'button-md-g': {...buttonStyle, ...stylesMd, ...shadowStyle},
        'button-sm-g': {...buttonStyle, ...stylesSm, ...shadowStyle},
        'secondary-lg': {...secondaryStyle, ...stylesLg},
        'secondary-md': {...secondaryStyle,...stylesMd},
        'secondary-sm': {...secondaryStyle, ...stylesSm},
        'solid-lg': {...solidStyle, ...stylesLg},
        'solid-md': {...solidStyle,...stylesMd},
        'solid-sm': {...solidStyle, ...stylesSm},
        'ghost-lg': {...ghostStyle, ...stylesLg},
        'ghost-md': {...ghostStyle,...stylesMd},
        'ghost-sm': {...ghostStyle, ...stylesSm},
      },
      baseStyle
    }
  }
};